import { QuarterlyReportsParams } from '@nextforce/api'

const keys = {
  all: ['performance_reports'],
  quarterlyReports: (params: QuarterlyReportsParams) => [...keys.all, params],
}

export default keys
